import MemberMySaVue from '@/views/member/my-sa/my-sa.vue';

const basePath = '/member/my-sa';
const role = 'member'; // 角色身份

export const M_MY_SA_INDEX = 'm-my-sa';
export const M_UNBIND_SUCCESS = 'm-unbind-success';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: MemberMySaVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: M_MY_SA_INDEX,
      component: () => import(
        /* webpackChunkName: "sign-up" */
        `@/views/${role}/my-sa/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/unbind-success`,
      name: M_UNBIND_SUCCESS,
      component: () => import(
        /* webpackChunkName: "sign-up" */
        `@/views/${role}/my-sa/unbind-success.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
